export default function Hero() {
  const stats = [
    { label: '每日更新', value: '24h 不间断' },
    { label: '独家爆料', value: '全网首发' },
    { label: '免费吃瓜', value: '永不收费' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20dramatic%20entertainment%20newsroom%20atmosphere%20with%20warm%20red%20and%20amber%20spotlights%2C%20cinematic%20lighting%2C%20moody%20editorial%20backdrop%20with%20subtle%20camera%20flashes%2C%20professional%20news%20studio%20vibe%2C%20deep%20shadows%20and%20warm%20highlights%2C%20atmospheric%20depth&width=1600&height=900&seq=hero-bg-51hlw&orientation=landscape"
          alt="51黑料网娱乐新闻背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-200 text-sm font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>今日猛料持续更新中
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4">
              51黑料网
              <span className="block text-xl sm:text-2xl md:text-3xl lg:text-4xl font-normal text-background-50/80 mt-2">
                娱乐圈吃瓜第一线
              </span>
            </h1>

            <p className="text-accent-300 text-base sm:text-lg md:text-xl font-medium mb-4 font-heading">
              网红聊天记录泄露 · 明星塌房内幕 · 独家大瓜视频站
            </p>

            <p className="text-background-50/70 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              全网吃瓜第一线，51黑料网实时深扒娱乐圈最劲爆大瓜。每日更新网红反差视频、明星翻车实锤与独家泄漏秘闻，
              海量黑料在线免费看，吃瓜传送门时刻待命，速来围观今日猛料！
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-accent-400 text-lg md:text-xl font-bold font-heading">{s.value}</div>
                  <div className="text-background-50/50 text-xs mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleNavClick(e, '#updates')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors flex items-center justify-center gap-2"
              >
                <i className="ri-flashlight-line"></i>立即吃瓜
              </a>
              <a
                href="#cards"
                onClick={(e) => handleNavClick(e, '#cards')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg border border-background-50/30 hover:border-background-50/60 text-background-50 hover:bg-white/10 font-medium text-sm whitespace-nowrap cursor-pointer transition-all flex items-center justify-center gap-2"
              >
                <i className="ri-article-line"></i>热门专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[480px] xl:max-w-[540px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20entertainment%20news%20collage%20with%20dramatic%20red%20and%20dark%20tones%2C%20paparazzi%20style%20photography%20vibe%2C%20breaking%20news%20aesthetic%2C%20bold%20typography%20mockup%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20professional%20media%20production%20feel%2C%20clean%20dark%20background%20with%20warm%20highlights&width=1080&height=1080&seq=hero-visual-51hlw&orientation=squarish"
                alt="51黑料网独家爆料主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <span className="text-background-50/90 text-xs font-medium flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                  实时追踪娱乐圈最新动态
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}